import { render, staticRenderFns } from "./ConfirmedUser.vue?vue&type=template&id=144490b7&"
import script from "./ConfirmedUser.vue?vue&type=script&lang=js&"
export * from "./ConfirmedUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports